import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class GoalDurationIsBelowMinium extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('The projected goal duration is below minimum', ...args);
    }
}
export default GoalDurationIsBelowMinium;
